import { Component, OnInit, Inject, Optional } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Utils } from 'src/app/core/utils/utils';

@Component({
  selector: 'app-dialogs-alert',
  templateUrl: './dialogs-alert.component.html',
  styleUrls: ['./dialogs-alert.component.scss']
})
export class DialogsAlertComponent implements OnInit {

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              @Optional() private dialogRef: MatDialogRef<DialogsAlertComponent>,
              public translate: TranslateService) { }

  texto: string = "";
  textoOk: string = "";

  ngOnInit() {
    this.texto = this.data.texto;
    this.textoOk = Utils.noUndfAndNull(this.data.textoOk, "", false) ? this.data.textoOk : this.translate.instant("aceptar");
  }

  /**
  * @description
  * Cierra el dialog
  */
  aceptar() {
    this.dialogRef.close(true);
  }

}

